import { createStore } from "zustand/vanilla"

import type { FiscalConfig } from "~/utils/fiscalCalendar"

type FiscalConfigState = {
  fiscalConfig: FiscalConfig | null
}

/**
 * The signed-in company's fiscal calendar, readable synchronously from pure utils so it doesn't
 * have to be threaded through every call chain (same pattern as number-format-store).
 *
 * CLIENT-ONLY: set while `_auth.tsx` renders with the `getCompany` result (and again after
 * Setup → General saves invalidate it), so pages rendered below it read the current calendar.
 * Server code must never write or read this — the store is a process-wide singleton and the server
 * serves many tenants per process. Server code passes `FiscalConfig` explicitly per request; since
 * the store is never hydrated in Node, an omitted config there resolves to `null` (the legacy
 * retail calendar), matching pre-store behavior.
 */
const fiscalConfigStore = createStore<FiscalConfigState>()(() => ({
  fiscalConfig: null,
}))

export function setFiscalConfig(fiscalConfig: FiscalConfig | null) {
  fiscalConfigStore.setState({ fiscalConfig })
}

export const getStoredFiscalConfig = () => fiscalConfigStore.getState().fiscalConfig
